import React from "react";
import { Box, ButtonBase, Paper, Typography } from "@mui/material";

export interface OverviewMetric {
  label: string;
  value: React.ReactNode;
  detail: string;
  color?: string;
  onClick?: () => void;
  selected?: boolean;
}

export default function OverviewMetrics({
  items,
}: {
  items: OverviewMetric[];
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          lg: `repeat(${items.length}, minmax(0, 1fr))`,
        },
        gap: 2,
      }}
    >
      {items.map((item) => {
        const content = (
          <>
            <Typography variant="body2" color="text.secondary" fontWeight={600}>
              {item.label}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                my: 0.75,
                fontSize: { xs: "1.9rem", md: "2.3rem" },
                fontWeight: 700,
                color: item.color || "text.primary",
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {item.value}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.detail}
            </Typography>
          </>
        );
        return (
          <Paper
            key={item.label}
            sx={{
              overflow: "hidden",
              borderRadius: '16px',
              position: "relative",
              "&::before": { content: '""', position: "absolute", left: 0, top: 24, width: 3, height: 28, borderRadius: 2, bgcolor: item.color || "primary.main", opacity: item.selected ? 1 : 0.55 },
              borderColor: item.selected ? "primary.main" : "divider",
              boxShadow: "none",
            }}
          >
            {item.onClick ? (
              <ButtonBase
                onClick={item.onClick}
                aria-pressed={!!item.selected}
                sx={{
                  p: { xs: 2, md: 2.5 },
                  width: "100%",
                  height: "100%",
                  display: "block",
                  textAlign: "left",
                  "&:hover": { bgcolor: "action.hover" },
                }}
              >
                {content}
              </ButtonBase>
            ) : (
              <Box sx={{ p: { xs: 2, md: 2.5 } }}>{content}</Box>
            )}
          </Paper>
        );
      })}
    </Box>
  );
}
